__turbopack_context__.v({
  "blocksBackgroundColor": "UserDropDownMenu-module-scss-module__WGONBW__blocksBackgroundColor",
  "blocksFontColor": "UserDropDownMenu-module-scss-module__WGONBW__blocksFontColor",
  "container": "UserDropDownMenu-module-scss-module__WGONBW__container",
  "containerOpen": "UserDropDownMenu-module-scss-module__WGONBW__containerOpen",
  "icon": "UserDropDownMenu-module-scss-module__WGONBW__icon",
  "navAvatar": "UserDropDownMenu-module-scss-module__WGONBW__navAvatar",
  "notificationIcon": "UserDropDownMenu-module-scss-module__WGONBW__notificationIcon",
  "secondaryNavBackgroundColor": "UserDropDownMenu-module-scss-module__WGONBW__secondaryNavBackgroundColor",
  "themeBackgroundColor": "UserDropDownMenu-module-scss-module__WGONBW__themeBackgroundColor",
  "themeFontColor": "UserDropDownMenu-module-scss-module__WGONBW__themeFontColor",
  "userMenu": "UserDropDownMenu-module-scss-module__WGONBW__userMenu",
  "userMenuButton": "UserDropDownMenu-module-scss-module__WGONBW__userMenuButton",
});
